import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/service/token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(
    private httpClient: HttpClient,
    public tokenStorage:TokenStorageService,
  ) { }

  errorHandler(error:any) {
    let errorMessage = '';
    if(error instanceof HttpErrorResponse) {
      errorMessage = error.error;
    } else {
      errorMessage = error;
    }
    return throwError(errorMessage);
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${this.tokenStorage.getToken()}`
    })
  }

  orderPlaced(data:any){
    return this.httpClient.post(environment.apiURL +'create-order',data,this.httpOptions).pipe(
      catchError(this.errorHandler)
    )
  }
  orderUpdate(id:any,data:any){
    return this.httpClient.post(environment.apiURL +'update-order/'+id,data,this.httpOptions).pipe(
      catchError(this.errorHandler)
    )
  }
  orderDelete(id:any){
    return this.httpClient.delete(environment.apiURL +'delete-order/'+id,this.httpOptions).pipe(
      catchError(this.errorHandler)
    )
  }
}
